import { render, staticRenderFns } from "./Suggest.vue?vue&type=template&id=42db6806&scoped=true"
import script from "./Suggest.vue?vue&type=script&lang=js"
export * from "./Suggest.vue?vue&type=script&lang=js"
import style0 from "./Suggest.vue?vue&type=style&index=0&id=42db6806&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db6806",
  null
  
)

export default component.exports